<template>
  <div>
    <!-- 切换购买出售以及币种 -->
<!--    <status-bar @search="search"/>-->
    <div class="tab-other-container">
      <div class="status">
        <div class="status-item" :class="{active: index == status,buy: index == 0,sell: index == 1,}" v-for="(item, index) in statusList" @click="changeStatus(index)" :key="item">{{$t(item)}}</div>
      </div>
      <div class="coin-type">
        <div class="coin-type-item" :class="{ active: currency_value == item.key }" v-for="item in currencyList" @click="changeCurrencyType(item.key)" :key="item.id">{{ item.value | upcase }}</div>
      </div>
    </div>
    <!-- 表头筛选 -->
    <div class="tab-extra-container flex-center">
      <div class="item">
        <!--金额-->
        <div class="item-label">{{$t('400163')}}</div>
        <div class="custom-input">
          <!--输入金额-->
          <el-input v-model="amount" @input="inputChange" :placeholder="$t('400164')">
            <template slot="suffix" class="flex-center">
              <span class="bosiMoneyStyle inline-block">{{fiat_value}}</span>
              <el-button type="text" @click="search">{{$t('400071')}}</el-button>
            </template>
          </el-input>
        </div>
      </div>
      <div class="item">
        <!--法币-->
        <div class="item-label">{{$t('400165')}}</div>
        <FiatSelect v-model="fiat_value" @change="changeFait" :fiatAll="fiatAll" :activeUrl="activeUrl"></FiatSelect>
      </div>
      <div class="item pay">
        <!--支付方式-->
        <div class="item-label">{{$t('400125')}}</div>
        <el-select v-model="payFunc_value" filterable :placeholder="$t('400166')" @change="search" clearable :popper-append-to-body="false" :no-match-text="$t('400025')">
          <!--所有支付方式-->
          <el-option value="" :label="$t('400166')"></el-option>
          <el-option :value="p.value" v-for="p in paymentCopy" :key="p.value" :label="p.key">
            <em class="inline-block normal" style="width: 4px;height: 12px;border-radius: 2px;vertical-align: -1px;" :style="{ backgroundColor: p.extra }"></em>&nbsp;&nbsp;{{p.key}}
          </el-option>
        </el-select>
      </div>
    </div>
<!--    <table-filter @search="search"/>-->
    <!-- 表格 -->
    <ContentTableCopy :listData="listData" @search="search" :page="page" :status="status"></ContentTableCopy>
    <question-container :status="status1"/>
    <advantage-container/>
  </div>
</template>

<script>
import {search} from "../api";
import QuestionContainer from "./components/QuestionContainer.vue";
import AdvantageContainer from "./components/AdvantageContainer.vue";
import StatusBar from "./components/StatusBar.vue";
import ContentTableCopy from "@/views/buycoin/buycoin/components/ContentTableCopy";
import {getEnumList,faitPayment} from "@/apis/C2C";
import FiatSelect from "@/components/FiatSelect.vue";
import {mapGetters} from "vuex";
import tipModel from "@/components/publicModel/tipModel";
export default {
    metaInfo() {
        return {
            title: this.p2pTitle,
        }
    },
  components: {
    QuestionContainer,
    AdvantageContainer,
    // TableFilter,
    StatusBar,
    ContentTableCopy,
    FiatSelect,
    tipModel
  },
  data() {
    return {
      amount: "",
      listData: {
        items: [],
        total: 0,
      },
      statusList: ['400129', '400130'],
      status: 0,
      status1: 0,
      currency_value: '',
      payFunc_value: '',
      page: 1,
      pageSize: 10,
      currencyList: [],
      fiat_value: "",
      payments: [],
      paymentCopy: [],
      fiatAll: [],
      activeUrl: ''
    };
  },
  computed: {
    ...mapGetters(['C2CUserInfo','token']),
    p2pTitle(){
        return this.$t('400244')
    }
  },
  created() {
    this.getEnumList()
    this.status = this.$route.query.status ? this.$route.query.status : 0
  },
  mounted(){
    // document.title = 'Buy Tether | Get USDT | SuperEx P2P'
  },
  methods: {
    async getEnumList() {
      const res = await getEnumList({type: 'all'})
      this.fiatAll = res.data.fiat || []
      if (this.token) {
        this.fiat_value = this.C2CUserInfo.tradableCurrency ? this.C2CUserInfo.tradableCurrency : this.fiatAll[0].value.toUpperCase()
      }else {
        this.fiat_value = this.fiatAll[0].value.toUpperCase()
      }
      this.activeUrl = this.fiatAll.find(v => v.value == this.fiat_value.toLowerCase()) ? this.fiatAll.find(v => v.value == this.fiat_value.toLowerCase()).extra : ''
      this.currencyList = res.data.currency || []
      this.currency_value = this.$route.query.currency ? this.$route.query.currency : res.data.currency[0].value
      this.getFaitPayment()
      this.search()
    },
    async getFaitPayment() {
      const res = await faitPayment({fiat: this.fiat_value})
      this.payments = res.data || []
      this.paymentCopy = res.data || []
    },
    inputChange(val) {
      this.amount = this.amount.replace(/[^0-9.]/g, '')
    },
    changeCurrencyType(key) {
      this.currency_value = key;
      this.search();
    },
    changeStatus(index) {
      this.status = index;
      this.search();
    },
    changeFait() {
      this.payFunc_value = ''
      this.getFaitPayment()
      this.search()
    },
    search(config) {
      this.page = config && config.page ? config.page : 1;
      search({
        currency: this.currency_value || null,
        fiat: this.fiat_value || null,
        paymentMethod: this.payFunc_value || null,
        amount: this.amount || null,
        adType: Number(this.status) + 1,
        page: this.page,
        pageSize: this.pageSize,
      }).then((res) => {
        res.items.forEach(v => {
          v.active = false
        })
        this.listData = res;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
@import "@/assets/css/variable.scss";
.tab-other-container {
  ::v-deep .el-table th.el-table__cell {
    background: transparent !important;
  }
  display: flex;
  align-items: center;
  margin: 0 auto 35px;
  width: 1200px;
  .status {
    @include background-color("background-color-hover");
    border-radius: 14px;
    display: flex;
    &-item {
      height: 28px;
      line-height: 28px;
      border-radius: inherit;
      font-size: 14px;
      @include font_color('font-color-1');
      cursor: pointer;
      padding: 0 14px;
    }
    &-item.active.buy {
      background-color: #00b464;
      color: #ffffff;
    }
    &-item.active.sell {
      background-color: #fa4d56;
      color: #ffffff;
    }
  }

  .coin-type {
    display: flex;
    height: 28px;
    align-items: center;
    margin: 0 16px;
    padding: 0 4px;
    @include background-color("background-color-hover");
    border-radius: 14px;

    &-item {
      height: 20px;
      line-height: 20px;
      @include font_color('font-color-1');
      font-size: 12px;
      cursor: pointer;
      padding: 0 8px;
      &.active {
        background-color: #ffc72b;
        color: #000922;
        border-radius: 10px;
      }
    }
  }
}

.tab-extra-container {
  margin: 0 auto 35px;
  width: 1200px;
  .item{
    // margin-right: 48px;
    .item-label{
      font-size: $font-size-mini;
      @include font_color('font-color-1');
      margin-bottom: 8px;
    }
    .custom-input{
      width: 320px;
      ::v-deep .el-input__inner{
        background-color: transparent;
        padding-right: 120px;
      }
      ::v-deep .el-input__suffix{
        line-height: 40px;
        span.inline-block{
          padding-right: 10px;
          @include font_color('font-color');
        }
      }
      ::v-deep .el-button{
        border: none;
        border-radius: 0;
      }
      ::v-deep .el-button--text{
        padding: 0 10px;
        // border-left: 1px solid;
        @include border_color('border-color-normal-2');
      }
    }
  }
}

.page-buycoin {
  .otc-container-other {
    padding-top: 24px;
    //max-width: 1920px;
    //width: 1200px;
    margin: 0 auto;
    max-height: 900px;
  }
}
.bosiMoneyStyle{
  right: 105px;
}
</style>
<style lang="scss">
[dir = 'ltr'] .tab-extra-container {
  .item{
    margin-right: 48px;
  }
}
[dir = 'rtl'] .tab-extra-container {
  .item{
    margin-left: 48px;
  }
}
[dir = 'ltr'] .tab-extra-container .item .custom-input .el-button--text{
  border-left: 1px solid;
}
[dir = 'rtl'] .tab-extra-container .item .custom-input .el-button--text{
  border-right: 1px solid;
}
[dir = 'rtl'] .tab-extra-container .item .custom-input .el-input__suffix span.inline-block{
  padding-left: 10px;
}
[dir = 'rtl'] .tab-extra-container .item .custom-input .el-input__inner{
  padding-right: 10px;
}
[dir = 'rtl'] .tab-extra-container .item .custom-input .el-input__suffix{
  right: 180px;
}
</style>